import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "../store/store";
import type { ReactNode } from "react";
import { initializeAuthState } from "@utils/auth";
import { useEffect } from "react";

interface ReduxProviderProps {
	children: ReactNode;
}

export const ReduxProvider = ({ children }: ReduxProviderProps) => {
	useEffect(() => {
		initializeAuthState();
	}, []);

	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				{children}
			</PersistGate>
		</Provider>
	);
};
